import { useTranslation } from "react-i18next"
import type { TActivity } from "@/types"
import { buildActivityURL } from "@/utils"
import { AppLink } from "../utils"

export const activityTitle: Record<TActivity["type"], string> = {
  anniversary: "Anniversaries",
  coffee: "Coffee Chats",
  experience: "Workshops",
  feedback: "Team Feedback",
  recognition: "Recognition",
  reimbursement: "Reimbursements",
  onboarding: "Onboarding",
  other: "Workshops",
  party: "Parties",
  people: "People",
  playbook: "Playbooks",
  pulse: "Pulses",
  radio: "Radio",
  survey: "Surveys",
  vacation: "Vacations",
}

export function ActivityLink({ activity }: { activity: Pick<TActivity, "type"> }) {
  const { t } = useTranslation()
  return <AppLink href={buildActivityURL(activity)}>{t(activityTitle[activity.type] || activityTitle.other)}</AppLink>
}
